export function cancelTimer(timer) {
    if (timer) {
        clearTimeout(timer);
    }
    return undefined;
}
